<pos-app-spinner [show]="isThinking"></pos-app-spinner>
<div class="row">
  <div class="col-12">
    <div class="d-flex justify-content-end flex-wrap" placement="top-right">
      <button type="button" class="btn mb-1" style="margin-left: 6px" (click)="openOrderNoteClick()">
        ORDER NOTES <span class="badge badge-light ml-1 bg-dark">{{ allAttachments?.length }}</span>
      </button>
    </div>
  </div>
</div>

<ag-grid-angular
  #orderGrid
  class="ag-theme-balham datagrid"
  [ngClass]="{ readonly: isReadOnly }"
  [enableRangeSelection]="true"
  [rowDragManaged]="true"
  [context]="{ componentParent: this }"
  [frameworkComponents]="frameworkComponents"
  [gridOptions]="gridOptions"
  [rowClassRules]="rowClassRules"
  [processDataFromClipboard]="processDataFromClipboard"
  [getDataPath]="getDataPath"
  [treeData]="true"
  [groupDefaultExpanded]="-1"
  [domLayout]="'autoHeight'"
  [groupSuppressAutoColumn]="true"
  [tooltipShowDelay]="0"
  [immutableData]="true"
  [getRowNodeId]="getRowNodeId"
  (cellEditingStarted)="onCellEditingStarted()"
  (cellEditingStopped)="onCellEditingStopped($event)"
  (rowDragEnd)="onRowDragEnd($event)"
  (rowDragLeave)="onRowDragLeave($event)"
  (cellDoubleClicked)="onCellDoubleClicked($event)"
  (cellClicked)="onCellClicked($event)"
  (rowDataUpdated)="onDataRendered()"
  (gridReady)="onGridReady($event)"
>
</ag-grid-angular>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading" id="modal-basic-title">
      {{ showPriceScales ? 'PRICE SCALES' : 'PRODUCT SEARCH' }}
    </h3>
  </div>
  <div class="modal-body">
    <app-order-grid-item-search
      *ngIf="!showPriceScales"
      [searchStr]="itemSearchStr"
      (addingItem)="addSearchedItem($event)"
      (closeActiveModal)="handleCloseModal($event)"
    ></app-order-grid-item-search>
    <pos-app-item-price-scales
      *ngIf="showPriceScales"
      [item]="itemPricesToShow"
      [displayOptions]="displayOptions"
      [isExternal]="isExternalUser"
      (closeActiveModal)="handleCloseModal($event)"
    >
    </pos-app-item-price-scales>
  </div>
</ng-template>

<app-orders-buyin-supplier
  *ngIf="addingBuyin || editingBuyin"
  [buyinProduct]="editingBuyin"
  [defaultMarkup]="brandDefaults.buyinMarkupPerc"
  (toAddBuyin)="handleBuyin($event)"
  (addItemsToOrder)="addItemsToOrder.emit({ items: $event, enforceItemRule: viewSettings.enforceItemRule })"
></app-orders-buyin-supplier>

<ng-template #lineAttachmentContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading" id="modal-basic-title">LINE NOTE</h3>
  </div>
  <div class="modal-body">
    <app-line-order-attachments
      [orderDetails]="orderDetails"
      [orderType]="orderHeader.orderType"
      [orderCompany]="orderHeader.orderCompany"
      [isReadOnly]="isReadOnlyLineAttachment"
      (refreshOrderGrid)="refreshOrderGrid()"
      (closeActiveModal)="handleCloseModal($event)"
    ></app-line-order-attachments>
  </div>
</ng-template>
